import React from "react"
import style from "./grid.module.scss"


class Grid extends React.Component<any, {}> {
  gridRef: React.RefObject<any>;

  constructor(props: any) {
    super(props);
    this.gridRef = React.createRef();
  }
  render() {
    return (
      <div className={style.grid} ref={this.gridRef}>
        {this.props.children}
      </div>
    );
  }
  componentDidMount() {
    require("animate-css-grid").wrapGrid(this.gridRef.current, {
      duration: 800
    });
  }
}

export default Grid;